import React, { useState } from 'react';
import { MainThemeBootstrap } from '../Theme/MainThemeBootstrap';
import { MainThemeSideBar } from '../Theme/MainThemeSideBar';
import { Fixtures } from '../OSV/Fixtures';
import { OutstandingRequirements } from '../OSV/OutstandingRequirements';
import { Availabilities } from '../OSV/Availabilities';
import { LayUpList } from '../OSV/LayUpList';
import { OSVRegions as Regions } from '../common/types';
import { FOSBSVesselSearch } from '../common/FOSBSVesselSearch';
import { NavLink } from 'react-router-dom';

export const OSV = () => {
  const [tab, setTab] = useState<Regions>(Regions.All);

  return (
    <div>
      <MainThemeBootstrap>
        <div className='container-fluid'>
          <div className='row pt-3'>
            <div className='col-12'>
              <FOSBSVesselSearch></FOSBSVesselSearch>
            </div>
          </div>
          <div className='row pt-3'>
            <div className='col-10 main-column'>
              <ul className='nav nav-tabs' style={{ marginBottom: '20px' }}>
                {Object.keys(Regions).map((key, idx) => {
                  return (
                    <li className='nav-item'>
                      <NavLink
                        to={{ pathname: '/osv', search: `region=${key}` }}
                        className='nav-link'
                        isActive={(_, location) => {
                          if (location.search === `?region=${key}`) {
                            setTab(key as Regions);
                            return true;
                          }

                          return false;
                        }}
                      >
                        {(Regions as any)[key]}
                      </NavLink>
                    </li>
                  );
                })}
              </ul>

              <Fixtures region={tab}></Fixtures>
              <br></br>

              <OutstandingRequirements tab={tab}></OutstandingRequirements>
              <br></br>

              <Availabilities region={tab}></Availabilities>
              <br></br>

              <LayUpList region={tab}></LayUpList>
            </div>

            <div className='col-2 sidebar-column'>
              <MainThemeSideBar></MainThemeSideBar>
            </div>
          </div>
        </div>
      </MainThemeBootstrap>
    </div>
  );
};
